import React from 'react';

import * as analytics from 'analytics/Analytics';
import {ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';
import {COMMON_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import runModal from 'ui-library/runModal';

import CreateJellyfishModal from './CreateJellyfishModal';

function handleClickNewJellyfish(): void {
  analytics.trackEventWithModule(COMMON_ANALYTICS_ACTIONS.OPENED_MODAL, ANALYTICS_MODULE.BENCHLING_APPS, {
    modalType: 'create_jellyfish',
  });
  runModal(CreateJellyfishModal, {});
}

export default function CreateJellyfishButton(): JSX.Element {
  return (
    <Tooltip text="Add jellyfish" placement={FloatingPlacement.BOTTOM}>
      <Button
        buttonStyle={ButtonStyle.SECONDARY}
        icon="compose"
        onClick={handleClickNewJellyfish}
        size={ButtonSize.SMALL}
      />
    </Tooltip>
  );
}
